<template>
  <div class="container w100 relative-container">
    <div class="padded">
      <step-counter :paso="config.pasos.configuracion.paso" />
      <wrap-container class="w50-fixed">
        <form-validator>
          <wrap-container>
            <p
              id="antetitulo"
              class="titulo antetitulo p28 light oscuro"
              v-if="config.pasos.configuracion.antetitulo"
              v-safe-html="config.pasos.configuracion.antetitulo"
            />
            <p
              class="titulo p32 medium oscuro"
              v-safe-html="config.pasos.configuracion.titulo"
            />
            <div class="subtitulo">
              <p
                class="titulo oscuro"
                v-safe-html="config.pasos.configuracion.subtitulo"
              />
            </div>
          </wrap-container>
          <wrap-container class="container-domicilios">
            <section-label value="¿Dónde querés recibir la tarjeta?" />
            <address-selector
              v-model="model.selectDomicilio"
              :particular="modelDomicilio"
              :otro="modelDomicilioAlternativo"
              @cerrar-modal="cerrarModal"
              :required="true"
              analyticsNameSalesButtonRecibido="listo"
              analyticsNameCustomLink="modificar"
              analyticsName="otro domicilio"
              quantumObfuscate
            />
          </wrap-container>
          <wrap-container class="grid-container grid-container--6-6">
            <wrap-container class="col1">
              <section-label value="Celular" />
              <phone-data
                v-if="hasInitialPhone"
                v-model="celular"
                quantumObfuscate
              />
              <phone-number
                v-else
                name="celular"
                v-model="celular"
                :required="true"
                quantumObfuscate
              />
            </wrap-container>
          </wrap-container>

          <wrap-container>
            <section-label value="Elegí una sucursal" />
            <wrap-container>
              <branch-offices
                class="col1"
                :required="true"
                v-model="model.sucursal"
                quantumObfuscate
              />
            </wrap-container>
          </wrap-container>
          <wrap-container class="resumen">
            <p>
              Al continuar, acepto el
              <a
                @click="mostrarResumen()"
                class="link-resumen"
                target="_blank"
                rel="noopener"
              >
                resumen de {{ nombreProducto }}
              </a>
              incluidos en esta solicitud.
            </p>
          </wrap-container>
          <wrap-container>
            <wrap-container>
              <sales-button
                ref="salesbutton"
                @click="confirmar()"
                label="Continuar"
              />
            </wrap-container>
            <button class="anterior-link" type="button" @click="atras">
              Anterior
            </button>
          </wrap-container>
        </form-validator>
      </wrap-container>
    </div>
    <modal-component
      :label="resumen.titulo"
      :show="showResumen"
      :buttonLabel="resumen.boton"
      @close="showResumen = false"
      @aceptar="windowResumen"
    >
      <pdf-viewer :src="resumen.url" />
    </modal-component>
  </div>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import FormValidator from "@/components/core/FormValidator";
import BranchOffices from "@/components/core/composite/combos/BranchOffices";
import AddressSelector from "@/components/core/custom/domicilio/AddressSelector";
import StepCounter from "@/components/core/StepCounter";
import SectionLabel from "@/components/core/SectionLabel";
import SalesButton from "@/components/core/SalesButton";
import PhoneData from "@/components/core/PhoneData";
import PhoneNumber from "@/components/core/composite/PhoneNumber.vue";
import ModalComponent from "@/components/core/ModalComponent.vue";
import PdfViewer from "@/components/core/custom/PdfViewer";
import { PCG7 } from "@/config/constants/index";
import { nombreCircuito } from "../config/constants";

export default {
  name: "Configuracion",
  components: {
    WrapContainer,
    FormValidator,
    AddressSelector,
    StepCounter,
    SectionLabel,
    SalesButton,
    BranchOffices,
    PhoneData,
    PhoneNumber,
    ModalComponent,
    PdfViewer
  },
  data() {
    return {
      model: this.$store.getters.getConfiguracion(),
      modelDomicilio: this.$store.getters.getDomicilio(PCG7.TDOMIC.PARTICULAR),
      modelDomicilioAlternativo: this.$store.getters.getDomicilio(
        PCG7.TDOMIC.CORRESPONDENCIA
      ),
      celular: this.$store.getters.getConsulta().celular,
      resultVeridas: this.$store.getters.getResultVeridas(),
      resumen: {
        titulo: "Resumen",
        url: "https://www.bbva.com.ar/tablas/RES_CA_PESOS.pdf",
        boton: "Descargar"
      },
      showResumen: false,
      hasInitialPhone: false,
      nombreProducto: nombreCircuito[this.$store.getters.getConsulta().circuito]
    };
  },

  mounted() {
    // Watch del domicilio
    this.$store.watch(
      () => {
        return [
          this.$store.getters.getDomicilio(PCG7.TDOMIC.PARTICULAR),
          this.$store.getters.getDomicilio(PCG7.TDOMIC.CORRESPONDENCIA)
        ];
      },
      domicilios => {
        this.modelDomicilio = domicilios[0];
        this.modelDomicilioAlternativo = domicilios[1];
      },
      { immediate: true }
    );
    // Si el usuario no tiene cargado el celular,
    // pedirlo ahora
    this.hasInitialPhone = this.celular.numero;
  },
  computed: {
    codigoPostal() {
      /* Parsear el CP de acuerdo al domicilio seleccionado */
      return this.model.selectDomicilio === "otro"
        ? this.model.otroDomicilio.codigoPostal
        : this.model.domicilioParticular.codigoPostal;
    },
    beneficiosTC() {
      return this.$store.getters.getPaquetesBeneficios();
    }
  },
  methods: {
    cerrarModal(valid) {
      if (!valid && !this.modelDomicilioAlternativo.inusual) {
        this.model.selectDomicilio = "particular";
      }
    },
    confirmar() {
      this.$store.dispatch("DO_CONFIGURACION", {
        ...this.model,
        celular: this.celular
      });
    },
    atras() {
      this.$router.push(
        this.config.pasos[this.config.pasos.configuracion.pasoAnterior].path
      );
    },
    mostrarResumen() {
      this.$store.dispatch("DO_HUELLA_AVANZADA", "terminos y condiciones");
      this.showResumen = true;
    },
    windowResumen() {
      window.open(this.resumen.url);
    }
  }
};
</script>

<style scoped>
.cobranding-logo-header {
  top: 36px;
}

.subtitulo {
  font-size: 15px;
  line-height: 1.3em;
}

.anterior-link {
  cursor: pointer;
  font-size: 15px;
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  font-weight: bold;
  color: #237aba;
  padding: 8px 0 8px 40px;
  margin-top: 32px;
  margin-bottom: 30px;
  border: none;
  background-color: #ffffff;
  background-repeat: no-repeat;
  background-image: url("../assets/img/1x/Arrow-Left.png");
  background-position: 0 8px;
}

.resumen {
  margin-top: 50px;
  margin-bottom: 50px;
}

.link-resumen {
  color: #0070bd;
  text-decoration: none;
  font-size: 14px;
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
}
</style>
